import NumberType from "../../types/report/NumberType";

const updateNumbers = (item: NumberType[]) => {

    for (var i = 0; i < item.length; i++) {
        item[i].number = i + 1;
    }
}

export { updateNumbers }
